export const PONTO_INCOMPLETO = {
  value: 'PONTO_INCOMPLETO',
  label: 'Ponto Incompleto',
  numberValue: 0,
};
export const FALTA_SEM_JUSTIFICATIVA = {
  value: 'FALTA_SEM_JUSTIFICATIVA',
  label: 'Falta Sem Justificativa',
  numberValue: 1,
};
export const FALTAS_JUSTIFICADAS = {
  value: 'FALTAS_JUSTIFICADAS',
  label: 'Faltas Justificadas',
  numberValue: 2,
};
export const ATRASOS_SEM_JUSTIFICATIVA = {
  value: 'ATRASOS_SEM_JUSTIFICATIVA',
  label: 'Atrasos Sem Justificativa',
  numberValue: 3,
};
export const ATRASOS_JUSTIFICADOS = {
  value: 'ATRASOS_JUSTIFICADOS',
  label: 'Atrasos Justificados',
  numberValue: 4,
};
export const SAIDA_ANTECIPADA_SEM_JUSTIFICATIVA = {
  value: 'SAIDA_ANTECIPADA_SEM_JUSTIFICATIVA',
  label: 'Saida Antecipada Sem Justificativa',
  numberValue: 5,
};
export const SAIDA_ANTECIPADA_JUSTIFICADA = {
  value: 'SAIDA_ANTECIPADA_JUSTIFICADA',
  label: 'Saida Antecipada Justificada',
  numberValue: 6,
};
export const HORAS_EXTRAS_50 = {
  value: 'HORAS_EXTRAS_50',
  label: 'Horas Extras 50%',
  numberValue: 7,
};
export const HORAS_EXTRAS_60 = {
  value: 'HORAS_EXTRAS_60',
  label: 'Horas Extras 60%',
  numberValue: 8,
};
export const HORAS_EXTRAS_75 = {
  value: 'HORAS_EXTRAS_75',
  label: 'Horas Extras 75%',
  numberValue: 9,
};
export const HORAS_EXTRAS_80 = {
  value: 'HORAS_EXTRAS_80',
  label: 'Horas Extras 80%',
  numberValue: 10,
};
export const HORAS_EXTRAS_100 = {
  value: 'HORAS_EXTRAS_100',
  label: 'Horas Extra 100%',
  numberValue: 11,
};
export const HORAS_EXTRAS_140 = {
  value: 'HORAS_EXTRAS_140',
  label: 'Horas Extra 140%',
  numberValue: 12,
};
export const HORAS_EXTRAS_200 = {
  value: 'HORAS_EXTRAS_200',
  label: 'Horas Extra 200%',
  numberValue: 13,
};
export const HORAS_EXTRA_REFEICAO_100 = {
  value: 'HORAS_EXTRA_REFEICAO_100',
  label: 'Horas Extra Refeição 100%',
  numberValue: 14,
};
export const HORAS_EXTRA_REFEICAO_50 = {
  value: 'HORAS_EXTRA_REFEICAO_50',
  label: 'Horas Extra Refeição 50%',
  numberValue: 15,
};
export const HORAS_EXTRA_REFEICAO_60 = {
  value: 'HORAS_EXTRA_REFEICAO_60',
  label: 'Horas Extra Refeição 60%',
  numberValue: 16,
};
export const HORAS_EXTRA_REFEICAO_75 = {
  value: 'HORAS_EXTRA_REFEICAO_75',
  label: 'Horas Extra Refeição 75%',
  numberValue: 17,
};
export const HORAS_EXTRA_REFEICAO_80 = {
  value: 'HORAS_EXTRA_REFEICAO_80',
  label: 'Horas Extra Refeição 80%',
  numberValue: 18,
};
export const HORAS_TRABALHADAS = {
  value: 'HORAS_TRABALHADAS',
  label: 'Horas Trabalhadas',
  numberValue: 19,
};
export const HORAS_ADICIONALNOTURNO = {
  value: 'HORAS_ADICIONALNOTURNO',
  label: 'Horas Adicional Noturno',
  numberValue: 20,
};
export const HORAS_AFASTAMENTO = {
  value: 'HORAS_AFASTAMENTO',
  label: 'Horas Afastamento',
  numberValue: 21,
};
export const HORAS_ATESTADO = {
  value: 'HORAS_ATESTADO',
  label: 'Horas Atestado',
  numberValue: 22,
};
export const HORAS_FERIAS = {
  value: 'HORAS_FERIAS',
  label: 'Horas Ferias',
  numberValue: 23,
};
export const HORAS_EXTRAS_50_NOTURNO = {
  value: 'HORAS_EXTRAS_50_NOTURNO',
  label: 'Horas Extras 50% Noturno',
  numberValue: 24,
};
export const HORAS_EXTRAS_60_NOTURNO = {
  value: 'HORAS_EXTRAS_60_NOTURNO',
  label: 'Horas Extras 60% Noturno',
  numberValue: 25,
};
export const HORAS_EXTRAS_75_NOTURNO = {
  value: 'HORAS_EXTRAS_75_NOTURNO',
  label: 'Horas Extras 75% Noturno',
  numberValue: 26,
};
export const HORAS_EXTRAS_80_NOTURNO = {
  value: 'HORAS_EXTRAS_80_NOTURNO',
  label: 'Horas Extras 80% Noturno',
  numberValue: 27,
};
export const HORAS_EXTRAS_100_NOTURNO = {
  value: 'HORAS_EXTRAS_100_NOTURNO',
  label: 'Horas Extra 100% Noturno',
  numberValue: 28,
};
export const HORAS_EXTRA_REFEICAO_100_NOTURNO = {
  value: 'HORAS_EXTRA_REFEICAO_100_NOTURNO',
  label: 'Horas Extra Refeição 100% Noturno',
  numberValue: 29,
};
export const HORAS_EXTRA_REFEICAO_50_NOTURNO = {
  value: 'HORAS_EXTRA_REFEICAO_50_NOTURNO',
  label: 'Horas Extra Refeição 50% Noturno',
  numberValue: 30,
};
export const HORAS_EXTRA_REFEICAO_60_NOTURNO = {
  value: 'HORAS_EXTRA_REFEICAO_60_NOTURNO',
  label: 'Horas Extra Refeição 60% Noturno',
  numberValue: 31,
};
export const HORAS_EXTRA_REFEICAO_75_NOTURNO = {
  value: 'HORAS_EXTRA_REFEICAO_75_NOTURNO',
  label: 'Horas Extra Refeição 75% Noturno',
  numberValue: 32,
};
export const TURNONAOINICIADO = {
  value: 'TURNONAOINICIADO',
  label: 'Turno Não Iniciado',
  numberValue: 9991,
};
export const SEMMARCACAORECEBIDA = {
  value: 'SEMMARCACAORECEBIDA',
  label: 'Sem Marcação Recebido',
  numberValue: 9992,
};
export const PRESENTES = {
  value: 'PRESENTES',
  label: 'Presentes',
  numberValue: 9993,
};
export const AFASTADOS = {
  value: 'AFASTADOS',
  label: 'Afastados',
  numberValue: 9994,
};
export const FERIAS = { value: 'FERIAS', label: 'Férias', numberValue: 9995 };
export const FOLGA = { value: 'FOLGA', label: 'Folga', numberValue: 9999 };

export const ABSENCES_OCCURRENCY_ENUM = [
  FALTA_SEM_JUSTIFICATIVA,
  FALTAS_JUSTIFICADAS,
];

export const DELAYS_OCCURRENCY_ENUM = [
  ATRASOS_SEM_JUSTIFICATIVA,
  ATRASOS_JUSTIFICADOS,
  SAIDA_ANTECIPADA_SEM_JUSTIFICATIVA,
  SAIDA_ANTECIPADA_JUSTIFICADA,
];

export const EXTRAHOUR_OCCURRENCY_ENUM = [
  HORAS_EXTRAS_50,
  HORAS_EXTRAS_60,
  HORAS_EXTRAS_75,
  HORAS_EXTRAS_80,
  HORAS_EXTRAS_100,
  HORAS_EXTRAS_140,
  HORAS_EXTRAS_200,
  HORAS_EXTRA_REFEICAO_100,
  HORAS_EXTRA_REFEICAO_50,
  HORAS_EXTRA_REFEICAO_60,
  HORAS_EXTRA_REFEICAO_75,
  HORAS_EXTRA_REFEICAO_80,
  HORAS_EXTRAS_50_NOTURNO,
  HORAS_EXTRAS_60_NOTURNO,
  HORAS_EXTRAS_75_NOTURNO,
  HORAS_EXTRAS_80_NOTURNO,
  HORAS_EXTRAS_100_NOTURNO,
  HORAS_EXTRA_REFEICAO_100_NOTURNO,
  HORAS_EXTRA_REFEICAO_50_NOTURNO,
  HORAS_EXTRA_REFEICAO_60_NOTURNO,
  HORAS_EXTRA_REFEICAO_75_NOTURNO,
];

export const WORKEDHOUR_OCCURRENCY_ENUM = [
  HORAS_TRABALHADAS,
  HORAS_ADICIONALNOTURNO,
  HORAS_EXTRAS_50_NOTURNO,
];

export const VACATIONHOURS_OCCURRENCY_ENUM = [HORAS_FERIAS];
